import {request} from '@zoefin/request';

const BASE_URL = process.env.VERCEL_URL
  ? `https://${process.env.VERCEL_URL}`
  : 'http://localhost:3000';

export async function searchCoreUser(email: string): Promise<Prospect | null> {
  try {
    const coreResponse: {data: Prospect | null} = await request(
      `${BASE_URL}/api/core-cc/users/search`,
      {
        method: 'POST',
        body: {value: email},
      },
    );

    return coreResponse.data;
  } catch {
    return null;
  }
}

export async function redirectToDashboard(email: string): Promise<void> {
  const dashboardUrl = `${process.env.DASHBOARD_HOST || 'https://app.zoefin.com'}/auth/login?login_hint=${encodeURIComponent(email)}`;

  window.location.href = dashboardUrl;
}
